// Playout types - scheduled, logged interruptions of the program feed.
// See PLAN-playout.md for the design rationale.
export const PLAYOUT_TYPES = ["l-shape", "video-cutin"];
export const PLAYOUT_SNAP_TARGETS = [
    "top-left",
    "top-right",
    "bottom-left",
    "bottom-right",
];
/**
 * Playout owns ATEM media pool slots from here up; 1-10 belong to the studio.
 * This is the 1-based slot as shown in ATEM Software Control. `uploadStill`
 * takes a 0-based index, so subtract one before talking to the switcher.
 */
export const PLAYOUT_FIRST_MEDIA_SLOT = 11;
/** Overdue items still fire within this window, if they can finish in time. */
export const PLAYOUT_GRACE_SECONDS = 30;
export const DEFAULT_PLAYOUT_CONFIG = {
    connection_id: undefined,
    me_index: 1, // ME2
    ssrc_id: 0,
    program_source: 0,
    media_player: 0,
};
/** Shortest loop that still fits every item, used when none is configured. */
export const MIN_LOOP_SECONDS = 1;
/**
 * How long one pass through a looping playlist lasts.
 *
 * An explicit loop length wins, so a playlist can idle between passes. With
 * none, the loop is exactly as long as the playlist's content: from the run
 * anchor to the moment the last item leaves the air, rounded up to a whole
 * second so offsets stay tidy.
 *
 * `itemEnds` are the offsets at which each item finishes, animations included.
 */
export function loopLengthSeconds(playlist, itemEnds) {
    if (playlist.loop_seconds != null) {
        return Math.max(MIN_LOOP_SECONDS, playlist.loop_seconds);
    }
    const end = itemEnds.length > 0 ? Math.max(...itemEnds) : 0;
    return Math.max(MIN_LOOP_SECONDS, Math.ceil(end));
}
/** Used when nothing else says how long a still should stay up. */
export const DEFAULT_HOLD_SECONDS = 10;
/**
 * How long an item should stay on air, most specific source first:
 *
 *   1. the playlist item's own hold, when the operator set one
 *   2. an override on the asset
 *   3. the video's own duration
 *   4. a plain default, for stills with nothing else to go on
 *
 * A video therefore runs for its own length unless something deliberately says
 * otherwise, and nobody has to keep two numbers in sync by hand.
 */
export function effectiveHoldSeconds(asset, itemHoldSeconds) {
    if (itemHoldSeconds != null)
        return itemHoldSeconds;
    if (asset?.media_type === "video") {
        return (asset.hold_override_seconds ??
            asset.duration_seconds ??
            DEFAULT_HOLD_SECONDS);
    }
    return asset?.hold_override_seconds ?? DEFAULT_HOLD_SECONDS;
}
